'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _addNew = require('./addNew.component');

var _addNew2 = _interopRequireDefault(_addNew);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addNewModule = _angular2.default.module('addNew', [_angularUiRouter2.default]).component('addNew', _addNew2.default).name;

exports.default = addNewModule;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/information/addNew/addNew.js